const StoreType = {
    Undefined: 0,
    Shopify: 1,
    BigCommerce: 2,
    WooCommerce: 3,
    Magento: 4,
    Walmart: 5,
    Weebly: 6,
    Wix: 7,
    Etsy: 8,
    Miva: 9,
    Shoplazza: 10,
    Amazon: 11,
    Custom: 255
};
export const customily2StoreTypes = [
    StoreType.Shopify,
    StoreType.WooCommerce,
    StoreType.Etsy,
    StoreType.Shoplazza,
    StoreType.Custom
];
export default StoreType;
